type EscapeHandler = () => void;

const layers: EscapeHandler[] = [];

const handleKeyDown = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape' || event.defaultPrevented) {
        return;
    }
    const top = layers[layers.length - 1];
    if (top) {
        top();
    }
};

export const pushEscapeLayer = (handler: () => void): EscapeHandler => {
    if (layers.length === 0) {
        document.addEventListener('keydown', handleKeyDown);
    }
    layers.push(handler);
    return () => {
        const index = layers.lastIndexOf(handler);
        if (index !== -1) {
            layers.splice(index, 1);
        }
        if (layers.length === 0) {
            document.removeEventListener('keydown', handleKeyDown);
        }
    };
};
